import { Collapse, Descriptions, Typography } from "antd"
import { useTranslation } from "react-i18next"
import { PhoneItem } from "../respondents"
import { UseQueryResult } from "@tanstack/react-query"
import { IPresence } from "../../types"

const { Text } = Typography

const PersonalInfo: React.FC<{
  member: UseQueryResult<IPresence["member"]>
}> = ({ member }) => {
  const { t } = useTranslation()
  return (
    <>
      <Collapse
        items={[
          {
            key: "phones",
            label: t("labels.phone"),
            children: <PhoneItem data={member.data as any} />,
          },
          {
            key: "address",
            label: t("labels.address"),
            children: (
              <Descriptions
                items={[
                  {
                    key: "city",
                    label: <Text strong> {t("labels.city")}</Text>,
                    children: <Text>{(member.data as any)?.address.city}</Text>,
                  },
                  {
                    key: "street",
                    label: <Text strong> {t("labels.street")}</Text>,
                    children: (
                      <Text>{(member.data as any)?.address.street_1}</Text>
                    ),
                  },
                ]}
              />
            ),
          },
          {
            key: "transport",
            label: t("labels.transport"),
            children: (
              <Descriptions
                items={[
                  {
                    key: "transport",
                    label: <Text strong> {t("labels.transport_number")}</Text>,
                    children: (
                      <Text>{(member.data as any)?.transport_number}</Text>
                    ),
                  },
                ]}
              />
            ),
          },
        ]}
        defaultActiveKey={["1"]}
      />
    </>
  )
}

export default PersonalInfo
